import React from 'react';
import { Circle as IconOther } from 'react-feather';
import { palette } from '@jupiterone/jupiter-web-toolkit';
import { GraphVertex } from '../types';
import getStrokeColor from './getStrokeColor';

const viewBox = 48;
const iconSize = 24;
const radius = 18;
const pad = ((viewBox - iconSize) / 2) * 1.25;
const center = viewBox / 2;

interface IProps {
  icon: any;
  vertex: GraphVertex;
  selected: boolean;
}

const NodeIcon = ({ icon = IconOther, vertex, selected }: IProps) => {
  const defaultBackground = palette.background.paper;
  const selectedBackground = palette.primary.main;

  const defaultColor = palette.coolGrey[300];
  const selectedColor = palette.background.paper;

  const deleted = vertex.entity?._deleted;

  const backgroundColor =
    selected && !deleted ? selectedBackground : defaultBackground;
  const iconColor = selected && !deleted ? selectedColor : defaultColor;
  const specialStrokeColor = getStrokeColor(vertex);
  const strokeDasharray = deleted ? 8 : 0;
  const strokeWidth = specialStrokeColor ? 3.5 : 0;
  const strokeColor = specialStrokeColor || iconColor;
  const opacity = deleted ? 0.5 : 1;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={viewBox}
      height={viewBox}
      viewBox={`0 0 ${viewBox} ${viewBox}`}
    >
      <g transform={vertex.isPack ? 'translate(3, 0)' : ''}>
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill={backgroundColor}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeDasharray={strokeDasharray}
          opacity={opacity}
        />
        <g transform={`translate(${pad}, ${pad}), scale(0.75)`}>
          {React.createElement(icon, {
            color: iconColor,
            strokeWidth: 1.25,
          })}
        </g>
      </g>
      {vertex.isPack && (
        <g fill={backgroundColor} transform="scale(1.5) translate(0, 4)">
          <path
            d={
              'M4.877,12A12.935,12.935,0,0,1,6.886,5.061a.4.4,0,0,' +
              '0-.565-.554,9,9,0,0,0,0,14.986.4.4,0,0,0,.565-.554A12.935,12.935,0,0,1,4.877,12Z'
            }
          />
          <path
            d={
              'M1.294,12a9.95,9.95,0,0,1,.62-3.468A.406.406,0,0,0,1.2,' +
              '8.154a6.749,6.749,0,0,0,0,7.692.406.406,0,0,0,.711-.378A9.95,9.95,0,0,1,1.294,12Z'
            }
          />
        </g>
      )}
    </svg>
  );
};

export default NodeIcon;
